import costuto from '@/apis/costuto.js'
import helpers from '@/store/helpers.js'

const actions = {
  show: (context, payload) => {
    return new Promise((resolve, reject) => {
      costuto().get(`stores/${payload}`)
        .then(resp => {
          resolve(resp)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  create: (context, payload) => {
    const data = helpers.dataFormat('store', payload)
    return new Promise((resolve, reject) => {
      costuto().post('stores', data)
        .then(resp => {
          resolve(resp)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const modules = {
  reviews: {
    namespaced: true,
    actions: {
      index: (context, payload) => {
        return new Promise((resolve, reject) => {
          costuto().get(`stores/${payload}/reviews`)
            .then(resp => {
              resolve(resp)
            })
            .catch(error => {
              reject(error)
            })
        })
      },
      create: (context, { reviewable, review }) => {
        return new Promise((resolve, reject) => {
          let data = helpers.dataFormat('review', review)
          costuto().post(`stores/${reviewable}/reviews`, data)
            .then(resp => {
              resolve(resp)
            })
            .catch(error => {
              reject(error)
            })
        })
      },
      destroy: (context, { reviewable, review }) => {
        return new Promise((resolve, reject) => {
          costuto().delete(`stores/${reviewable}/reviews/${review}`)
            .then(resp => {
              resolve(resp)
            })
            .catch(error => {
              reject(error)
            })
        })
      },
      update: (context, { reviewable, review, payload }) => {
        let data = helpers.dataFormat('review', payload)
        return new Promise((resolve, reject) => {
          costuto().put(`stores/${reviewable}/reviews/${review}`, data)
            .then(resp => {
              resolve(resp)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  }
}

export default {
  namespaced: true,
  actions,
  modules
}
